import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    table: {
      loading: false,
      search: null,
      options: null,
      total_items: 0,
      headers: [
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.unit'), value: 'unit', width: 80, sortable: false },
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.logo'), value: 'logo', width: 200, sortable: false },
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.occupant_name'), value: 'name', width: 250, sortable: false },
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.phone_no'), value: 'phone_number', sortable: false },
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.email'), value: 'email', sortable: false },
        { text: Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.live_chat'), value: 'is_livechat', sortable: false },
        { text: Vuetify.locale.t('$vuetify.__General.description'), value: 'desc', sortable: false },
        { text: '', value: 'actions', width: 250, sortable: false }
      ],
      items: []
    }
  },
  mutations: {
    SET_DIRECTORY_DETAILS_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_DIRECTORY_DETAILS_SEARCH(state, payload) {
      state.table.search = payload
    },
    SET_DIRECTORY_DETAILS_TABLE_OPTIONS(state, payload) {
      state.table.options = payload
    },
    SET_DIRECTORY_DETAILS_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_DIRECTORY_DETAILS_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    }
  },
  actions: {
    async fetchDirectory({ commit, state }) {
      try {
        commit('SET_DIRECTORY_DETAILS_TABLE_ITEMS', [])
        commit('SET_DIRECTORY_DETAILS_TABLE_LOADING', true)
        commit('SET_DIRECTORY_DETAILS_TABLE_TOTAL_ITEMS', 0)

        const response = await api.getDirectoryList({ search: state.table.search })

        if (response.data.success) {
          commit('SET_DIRECTORY_DETAILS_TABLE_ITEMS', response.data.data)
          commit('SET_DIRECTORY_DETAILS_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DIRECTORY_DETAILS_TABLE_LOADING', false)
      }
    }
  }
}
